import * as React from "react";
import type { SVGProps } from "react";
const SvgBusRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#bus-right_svg__a)">
      <path d="M5.5 18.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m0-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5M19.5 18.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m0-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5" />
      <path d="M23 17h-2c-.55 0-1-.45-1-1s.45-1 1-1h1v-5c0-1.1-.9-2-2-2H3c-.55 0-1 .45-1 1v6h2c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V9c0-1.65 1.35-3 3-3h17c2.21 0 4 1.79 4 4v6c0 .55-.45 1-1 1" />
      <path d="M17 17H8c-.55 0-1-.45-1-1s.45-1 1-1h9c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M12 16c-.55 0-1-.45-1-1V7.5c0-.55.45-1 1-1s1 .45 1 1V15c0 .55-.45 1-1 1M16 16c-.55 0-1-.45-1-1V7.67c0-.55.45-1 1-1s1 .45 1 1V15c0 .55-.45 1-1 1" />
      <path d="M22.97 13h-2.56c-.53 0-1.04-.21-1.41-.59l-.41-.41H1c-.55 0-1-.45-1-1s.45-1 1-1h17.59c.53 0 1.04.21 1.41.59l.41.41h2.56c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="bus-right_svg__a">
        <path fill="#fff" d="M0 6h24v12.5H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBusRight;
